import { GET_MORE_CONTENT, MORE_CONTENT_API_SUCCESS, MORE_CONTENT_API_ERROR, CONTENTFUL_ENTRY_SUCCESS, } from '../../constants';
const initialState = {
    response: {},
    error: false,
    isGetMoreContentLoading: false,
};
const moreReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MORE_CONTENT:
            return {
                ...state,
                isGetMoreContentLoading: true,
            };
        case MORE_CONTENT_API_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isGetMoreContentLoading: false,
            };
        case MORE_CONTENT_API_ERROR:
            return {
                ...state,
                error: true,
                isGetMoreContentLoading: false,
            };
        case CONTENTFUL_ENTRY_SUCCESS:
            return {
                ...state,
                response: updateNewMoreEntry(state.response, action.updatedMoreResponse),
            };
        default:
            return state;
    }
};
export const updateNewMoreEntry = (response, newMoreResponse) => {
    let tempResponse = response;
    if (newMoreResponse?.hasMoreRootChange) {
        tempResponse.moreContent = newMoreResponse?.moreResponse[0];
        return tempResponse;
    }
    else {
        for (let i = 0; i < newMoreResponse?.moreResponse?.length; i++) {
            const newEntry = newMoreResponse?.moreResponse[i];
            tempResponse.moreContent.fields[newEntry?.indexObj] = newEntry;
        }
        return tempResponse;
    }
};
export default moreReducer;
